var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary-700 py-12"},[_c('view-header',{attrs:{"title":"Your Benefit Accounts Are Getting an Upgrade","image":"greenTrees2.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }